import React from 'react';
import PropTypes from 'prop-types';
import { Container, Dropdown, Icon } from 'rsuite';
import { storageDashboardPath, storageListPath } from '../../../routes/Paths';
import MainLayout from '../../../containers/MainLayout';
import MainContent from '../../MainContent';
import SidebarNav from '../../SidebarNav';
import NavLink from '../../NavLink';

const NAV_KEYS = {
  DASHBOARD: 1,
  DEVICE: 2
};

const StoragePageLayout = ({ children }) => (
  <MainLayout>
    <MainContent>
      <SidebarNav>
        <NavLink
          to={storageDashboardPath}
          eventKey={NAV_KEYS.DASHBOARD}
          icon={<Icon icon="dashboard" />}
        >
          Dashboard
        </NavLink>
        <Dropdown
          title="Storage Units"
          icon={<Icon icon="list-ul" />}
          eventKey={NAV_KEYS.DEVICE}
          placement="rightStart"
        >
          <NavLink to={storageListPath} eventKey={`${NAV_KEYS.DEVICE}_1`}>
            <Icon icon="list-alt" /> &nbsp; List
          </NavLink>
        </Dropdown>
      </SidebarNav>
      <Container>{children}</Container>
    </MainContent>
  </MainLayout>
);

StoragePageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default StoragePageLayout;
